import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { EFormEvent, useFormContext, useFormEventBus, useFormField } from '@cian/frontend-request-form-widget';
import * as React from 'react';
import { FileUploader } from '../../../components/FileUploader';
import { FormField } from '../../../components/FormField';
import { useFieldError } from '../../../utils/hooks';
import { removeFiles } from './utils/removeFiles';
import { fetchUploadsAttachments } from '../../../services/uploadsAttachments';
import { useApplicationContext } from '../../ApplicationContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var FileUploaderField = function FileUploaderField(props) {
  var _ref3;
  var label = props.label,
    name = props.name,
    required = props.required,
    description = props.description,
    _props$fileUploader = props.fileUploader,
    fileUploader = _props$fileUploader === void 0 ? {} : _props$fileUploader;
  var accept = fileUploader.accept,
    fileSizeLimit = fileUploader.fileSizeLimit,
    filesCountLimit = fileUploader.filesCountLimit;
  var _useFormContext = useFormContext(),
    isSubmitting = _useFormContext.isSubmitting;
  var _useFormField = useFormField({
      name: name
    }),
    _useFormField$field = _useFormField.field,
    _useFormField$field$v = _useFormField$field.value,
    value = _useFormField$field$v === void 0 ? [] : _useFormField$field$v,
    onBlur = _useFormField$field.onBlur,
    _useFormField$helpers = _useFormField.helpers,
    setValue = _useFormField$helpers.setValue,
    setError = _useFormField$helpers.setError;
  var _useFieldError = useFieldError(name),
    hideError = _useFieldError.hideError,
    errorMessage = _useFieldError.errorMessage,
    showError = _useFieldError.showError;
  var applicationContext = useApplicationContext();
  var formEventBus = useFormEventBus();
  var _React$useState = React.useState(value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    localFileState = _React$useState2[0],
    setLocalFileState = _React$useState2[1];
  var _React$useMemo = React.useMemo(function () {
      return {
        files: localFileState.map(function (_ref) {
          var sourceFile = _ref.sourceFile;
          return sourceFile;
        }),
        status: localFileState.map(function (_ref2) {
          var status = _ref2.status;
          return status;
        })
      };
    }, [localFileState]),
    files = _React$useMemo.files,
    status = _React$useMemo.status;

  /**
   * Синхронизируем локальное состояние файлов.
   * Formik не умеет как React.useState пробрасывать текущее состояние в колбеке,
   * поэтому мы используем реактовское состояние чтобы избежать гонки обратных связей.
   * Она может возникнуть в процессе загрузки файлов, если в момент когда файл загружен
   * пользователь добавит новый файл, то мы получим неконсистентное состояние.
   */
  React.useEffect(function () {
    // Нужно установить значение undefined, если текущее значение - пустой массив.
    // Это необходимо для того, чтобы корректно работал required() валидатор
    var value = localFileState.length > 0 ? localFileState : undefined;
    setValue(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localFileState]);

  /**
   * В случае сброса формы (вызывается onReset у Formik) нужно синхронизировать
   * реальное значение поля (field.value) и отображаемое (inputValue)
   */
  React.useEffect(function () {
    var unsubscribe = formEventBus.on(EFormEvent.AfterReset, function () {
      return setLocalFileState(value);
    });
    return unsubscribe;
  }, [formEventBus, value]);
  var uploadFiles = React.useCallback(function (_x) {
    return (_ref3 = _ref3 || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(files) {
      var errorMessage, uploadFilesResults, _iterator, _step, _loop;
      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            errorMessage = '';
            _context2.next = 3;
            return Promise.all(files.map(function (file) {
              return fetchUploadsAttachments(applicationContext, {
                files: [file]
              });
            }));
          case 3:
            uploadFilesResults = _context2.sent;
            _iterator = _createForOfIteratorHelper(uploadFilesResults);
            _context2.prev = 5;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var result;
              return _regeneratorRuntime.wrap(function _loop$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    result = _step.value;
                    setLocalFileState(function (currentFileState) {
                      return currentFileState.map(function (fileState) {
                        var nextFileState = result.files.find(function (f) {
                          return f.sourceFile.objectUrl === fileState.sourceFile.objectUrl;
                        });
                        if (nextFileState) {
                          return nextFileState;
                        }
                        return fileState;
                      });
                    });
                    if (result.errorMessage) {
                      errorMessage = result.errorMessage;
                    }
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _loop);
            });
            _iterator.s();
          case 8:
            if ((_step = _iterator.n()).done) {
              _context2.next = 12;
              break;
            }
            return _context2.delegateYield(_loop(), "t0", 10);
          case 10:
            _context2.next = 8;
            break;
          case 12:
            _context2.next = 17;
            break;
          case 14:
            _context2.prev = 14;
            _context2.t1 = _context2["catch"](5);
            _iterator.e(_context2.t1);
          case 17:
            _context2.prev = 17;
            _iterator.f();
            return _context2.finish(17);
          case 20:
            if (errorMessage) {
              setError(errorMessage);
              showError();
            }
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee, null, [[5, 14, 17, 20]]);
    }))).apply(this, arguments);
  }, [applicationContext, setError, showError]);
  var handleAdd = React.useCallback(function (files) {
    var addedFileState = files.map(function (item) {
      return {
        sourceFile: item,
        status: 'loading'
      };
    });
    setLocalFileState(function (currentFileState) {
      return [].concat(_toConsumableArray(currentFileState), _toConsumableArray(addedFileState));
    });
    uploadFiles(files);
  }, [uploadFiles]);
  var handleRemove = React.useCallback(function (file) {
    setLocalFileState(function (currentFileState) {
      return removeFiles(currentFileState, [file]);
    });
  }, []);
  var handleRetry = React.useCallback(function (file) {
    uploadFiles([file]);
  }, [uploadFiles]);
  var handleError = React.useCallback(function (message) {
    setError(message);
    showError();
  }, [showError, setError]);
  var handleClick = React.useCallback(function () {
    setError(undefined);
    hideError();
  }, [hideError, setError]);
  return /*#__PURE__*/_jsx(FormField, {
    label: label,
    description: description,
    errorMessage: errorMessage,
    required: required,
    children: function children(_ref4) {
      var id = _ref4.id;
      return /*#__PURE__*/_jsx(FileUploader, {
        id: id,
        name: name,
        files: files,
        status: status,
        accept: accept,
        filesCountLimit: filesCountLimit,
        fileSizeLimit: fileSizeLimit,
        disabled: isSubmitting,
        onAdd: handleAdd,
        onRemove: handleRemove,
        onError: handleError,
        onClick: handleClick,
        onRetry: handleRetry,
        onBlur: onBlur
      });
    }
  });
};